import React from 'react';
import styled from '@emotion/native';
import { IsDesktopProps } from '@/shared/styles/types';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import { FieldTitle } from '@/shared/styles/styledComponents/styledComponents';
import { BioData } from '@/shared/types/stylist';
import ErrorFrame from '@/shared/components/ErrorFrame';
import { BIO_MAX_LENGTH, HANDLE_MAX_LENGTH } from '@/shared/constants/utility';
import StaticInput from '@/shared/components/StaticInput';
import { mintGreenAlt } from '@/shared/styles/colors';

interface Props {
  bioData: BioData;
  setBioData: React.Dispatch<React.SetStateAction<BioData>>;
}

const Socials = ({ bioData, setBioData }: Props) => {
  const isDesktop = useIsDesktop();
  return (
    <OuterContainer isDesktop={isDesktop}>
      <FieldTitle marginBottom={20}>Short Bio*</FieldTitle>
      <ErrorFrame
        errorText={`Cannot exceed ${BIO_MAX_LENGTH} characters`}
        errorVisible={bioData.bio.length > BIO_MAX_LENGTH}
        containerStyle={{ marginBottom: 12 }}
      >
        <StaticInput
          placeholderText="Enter a short bio here"
          value={bioData.bio}
          onChange={(e) => setBioData({ ...bioData, bio: e.nativeEvent.text })}
          labelText="BIO"
          multiline
          customStyles={{
            height: 148,
            marginBottom: 0,
            borderWidth: 0,
          }}
          outlineStyle={{ borderColor: mintGreenAlt, borderRadius: 8 }}
        />
      </ErrorFrame>
      <FieldTitle marginBottom={20}>
        Social Media Platform (Optional)
      </FieldTitle>
      <ErrorFrame
        errorText={`Cannot exceed ${HANDLE_MAX_LENGTH} characters`}
        errorVisible={bioData.instagram.length > HANDLE_MAX_LENGTH}
      >
        <StaticInput
          placeholderText="Enter instagram handle here"
          value={bioData.instagram}
          onChange={(e) =>
            setBioData({ ...bioData, instagram: e.nativeEvent.text })
          }
          labelText="INSTAGRAM"
          customStyles={{ borderWidth: 0 }}
          outlineStyle={{ borderColor: mintGreenAlt }}
        />
      </ErrorFrame>
      <ErrorFrame
        errorText={`Cannot exceed ${HANDLE_MAX_LENGTH} characters`}
        errorVisible={bioData.tikTok.length > HANDLE_MAX_LENGTH}
      >
        <StaticInput
          placeholderText="Enter tiktok handle here"
          value={bioData.tikTok}
          onChange={(e) =>
            setBioData({ ...bioData, tikTok: e.nativeEvent.text })
          }
          labelText="TIKTOK"
          customStyles={{ borderWidth: 0 }}
          outlineStyle={{ borderColor: mintGreenAlt }}
        />
      </ErrorFrame>
      <ErrorFrame
        errorText={`Cannot exceed ${HANDLE_MAX_LENGTH} characters`}
        errorVisible={bioData.substack.length > HANDLE_MAX_LENGTH}
      >
        <StaticInput
          placeholderText="Enter substack handle here"
          value={bioData.substack}
          onChange={(e) =>
            setBioData({ ...bioData, substack: e.nativeEvent.text })
          }
          labelText="SUBSTACK"
          customStyles={{ borderWidth: 0 }}
          outlineStyle={{ borderColor: mintGreenAlt }}
        />
      </ErrorFrame>
    </OuterContainer>
  );
};

const OuterContainer = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  padding: isDesktop ? 32 : 0,
}));

export default Socials;
